import { useMemo } from 'react';
import type {
  ChecklistImportResultManifest,
  ChecklistImportResultRequest,
  ChecklistImportVerificationResponse,
  ChecklistImportVerificationReportResponse,
} from '@tcvs/shared';
import { useApi } from '../api';
import type { ApiRequestOptions, ApiResult } from '../auth/api-client';
type Client = { request<T>(path: string, options?: ApiRequestOptions): Promise<ApiResult<T>> };
export function createChecklistImportResultsApi(client: Client) {
  const post = <T>(body: ChecklistImportResultRequest) =>
    client.request<T>('/checklists/source-ingest', { method: 'POST', body });
  return {
    list: (batchId: string, cursor?: string) =>
      post<ChecklistImportResultManifest>({
        operation: 'BATCH_RESULTS',
        batchId,
        ...(cursor ? { cursor } : {}),
      }),
    start: (batchId: string, sourceTargetId: string, requestId: string) =>
      post<ChecklistImportVerificationResponse>({
        operation: 'VERIFY_START',
        batchId,
        sourceTargetId,
        requestId,
      }),
    advance: (
      batchId: string,
      sourceTargetId: string,
      sessionId: string,
      expectedVersion: number,
      requestId: string,
    ) =>
      post<ChecklistImportVerificationResponse>({
        operation: 'VERIFY_ADVANCE',
        batchId,
        sourceTargetId,
        sessionId,
        expectedVersion,
        requestId,
      }),
    status: (batchId: string, sourceTargetId: string, sessionId: string) =>
      post<ChecklistImportVerificationResponse>({
        operation: 'VERIFY_STATUS',
        batchId,
        sourceTargetId,
        sessionId,
      }),
    report: (batchId: string, sourceTargetId: string, reportId: string) =>
      post<ChecklistImportVerificationReportResponse>({
        operation: 'VERIFY_REPORT',
        batchId,
        sourceTargetId,
        reportId,
      }),
  };
}
export function useChecklistImportResultsApi() {
  const api = useApi();
  return useMemo(() => createChecklistImportResultsApi(api), [api]);
}
